import React from 'react';

export default ({ color = '#72747D' }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1667 18.3333H5.83333C3.9925 18.3333 2.5 16.8408 2.5 15C2.5 13.1591 3.9925 11.6666 5.83333 11.6666H14.1667"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1667 18.3333C16.0077 18.3333 17.5 16.8409 17.5 15C17.5 13.159 16.0077 11.6666 14.1667 11.6666C12.3258 11.6666 10.8334 13.159 10.8334 15C10.8334 16.8409 12.3258 18.3333 14.1667 18.3333Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83337 1.66663H14.1667C16.0075 1.66663 17.5 3.15913 17.5 4.99996C17.5 6.84079 16.0075 8.33329 14.1667 8.33329H5.83337"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83333 8.33329C7.67428 8.33329 9.16667 6.84091 9.16667 4.99996C9.16667 3.15901 7.67428 1.66663 5.83333 1.66663C3.99238 1.66663 2.5 3.15901 2.5 4.99996C2.5 6.84091 3.99238 8.33329 5.83333 8.33329Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
